/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from 'react';
import "@fontsource/roboto";
import "./relatorio.css";
import api from '../../../../../../services/api';
import { PictureAsPdfOutlined } from '@mui/icons-material';
import { PdfRelatorioGeral } from './pdfRelatorioGeral';
import {
    Typography, Button, DialogActions, Card, Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import StatusEstabelecimento from '../../../../../../utils/status/statusEstabelecimento';
import Paginacao from '../../../../../../utils/paginacao';
import GraficoEstabelecimento from '../../../../../../utils/graficoEstabelecimento';
import ProvinciaFilter from '../../../../../../filters/provinciaFilter';
import MunicipioFilter from '../../../../../../filters/municipioFilter';
import CategoriaFilter from '../../../../../../filters/categoriaFilter';
import EstadoEstabelecimentoFilter from '../../../../../../filters/estadoEstabelecimentoFilter';
import DataInicioFimFilter from '../../../../../../filters/dataInicio_dataFinal_Filter';
import { isDesktop } from 'react-device-detect';
import ListaVazia from '../../../../../../utils/listaVazia';
import DashboardSkeleton from '../../../../../../load/dashboardSkeleton';


interface Estabelecimento {
    municipio: any;
    directorTecnico: any;
    status: any;
    _id: string;
    logo: string;
    nome: string;
    createdAt: string;
    dataAprovacao: string;
    tipo: {
        createdAt: string | number | Date; designacao: string
    };
    empresa: {
        email: string;
        tel1: string;
    },
    provincia: string;
}

interface ConfigLista {
    nextPage: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    totalItems: number;
}

const prepararDadosGraficoPorMes = (dados: any[]) => {
    const meses = [
        "Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
        "Jul", "Ago", "Set", "Out", "Nov", "Dez"
    ];

    const contagemPorMes = meses.map((mes, index) => ({
        mes,
        mesIndex: index,
        total: 0
    }));

    dados.forEach(item => {
        const data = new Date(item.createdAt);
        const mesIndex = data.getMonth(); // 0 a 11
        contagemPorMes[mesIndex].total += 1;
    });

    return contagemPorMes;
};

const prepararDadosPorProvincia = (dados: any[]) => {
    const mapa: Record<string, number> = {};

    dados.forEach(item => {
        const provincia = item.provincia || "Sem província";

        mapa[provincia] = (mapa[provincia] || 0) + 1;
    });

    const totalGeral = Object.values(mapa).reduce((a, b) => a + b, 0);

    return Object.entries(mapa).map(([provincia, total]) => ({
        provincia,
        total,
        percentagem: totalGeral
            ? Number(((total / totalGeral) * 100).toFixed(1))
            : 0
    }));
};


export default function Geral() {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [esperaDados, setesperaDados] = useState(true);
    const [dados, setDados] = useState<string | undefined>('Activo');
    const [dadosEstabelecimento, setDadosEstabelecimento] = useState<Estabelecimento[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [dadosEstabelecimentoPaginated, setDadosEstabelecimentoPaginated] = useState<Estabelecimento[]>([]);
    const [dadosEstabelecimentoTotal, setDadosEstabelecimentoTotal] = useState<Estabelecimento[]>([]);
    const [dadosEstabelecimentoSubTotal, setDadosEstabelecimentoSubTotal] = useState<Estabelecimento[]>([]);
    const [anos, setAnos] = useState<string | undefined>('');
    const [anosFiltro, setAnosFiltro] = useState([]);
    const [municipio, setMunicipio] = useState('');
    const [provinciaSelecionada, setProvinciaSelecionada] = useState('');
    const [selectedTipos, setSelectedTipos] = useState('');
    const [totalItems, settotalItems] = useState(0);
    const [provincia, setProvincia] = useState<string>('');
    const [provinciaId, setProvinciaId] = useState<string>('');
    const [dataInicial, setDataInicio] = useState('');
    const [dataFinal, setDataFim] = useState('');
    const [dataAprovacaoInicio, setDataInicioAprovacao] = useState('');
    const [dataAprovacaoFim, setDataFimAprovacao] = useState('');
    const [dadosGraficoMes, setDadosGraficoMes] = useState<any[]>([]);
    const [chartDataProvincia, setChartDataProvincia] = useState<any[]>([]);
    const [provinciaSelecionadaGrafico, setProvinciaSelecionadaGrafico] = useState<string | null>(null);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(30);
    const [configLista, setConfigLista] = useState<ConfigLista>({
        nextPage: 1,
        hasPreviousPage: false,
        hasNextPage: false,
        totalItems: 0,
    });

    useEffect(() => {
        api.get(`/estabelecimentos`).then(response => {
            settotalItems(response?.data?.totalItems ?? '');
        }).catch(error => {
        })
    }, []);


    useEffect(() => {
        setesperaDados(true);
        api.get(`/estabelecimentos?perPage=${totalItems}&provincia=${provincia}&municipio=${municipio}&dataInicio=${dataInicial}&dataFim=${dataFinal}&dataAprovacaoInicio=${dataAprovacaoInicio}&dataAprovacaoFim=${dataAprovacaoFim}&tipoId=${selectedTipos}&status=${dados}&page=${page}&perPage=${perPage}&sortBy=createdAt:DESC`)
            .then(response => {
                const anosUnicos: any = Array.from(
                    new Set(response.data.estabelecimentos.map((estabelecimento: any) =>
                        new Date(estabelecimento.createdAt).getFullYear()
                    ))
                );

                setConfigLista({
                    nextPage: response.data.nextPage || 1,
                    hasPreviousPage: response.data.hasPreviousPage || false,
                    hasNextPage: response.data.hasNextPage || false,
                    totalItems: response.data.totalItems || 0,
                });
                setAnosFiltro(anosUnicos);
                setDadosEstabelecimento(response.data.estabelecimentos || []);
                setesperaDados(false);
            })
            .catch(error => {
                setesperaDados(false);
            });
    }, [provincia, municipio, dados, totalItems, selectedTipos, page, perPage, dataInicial, dataFinal, provinciaSelecionadaGrafico, dataAprovacaoFim, dataAprovacaoInicio]);


    const anoAtual = new Date().getFullYear();
    const anoGrafico = anos ? Number(anos) : anoAtual;

    useEffect(() => {
        const dataInicio = dataInicial ? new Date(dataInicial) : null;
        const dataFim = dataFinal ? new Date(dataFinal) : null;

        const filteredData = dadosEstabelecimento.filter(dado => {
            const createdAt = new Date(dado.createdAt);

            if (anos && createdAt.getFullYear() !== Number(anos)) return false;
            if (dataInicio && createdAt < dataInicio) return false;
            if (dataFim && createdAt > dataFim) return false;

            if (
                provinciaSelecionadaGrafico &&
                dado.provincia !== provinciaSelecionadaGrafico
            ) {
                return false;
            }

            return true;
        });

        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;

        setDadosEstabelecimentoTotal(filteredData);
        setDadosEstabelecimentoPaginated(filteredData.slice(startIndex, endIndex));

        const dadosAnoAtual = dadosEstabelecimento.filter(dado => {
            const createdAt = new Date(dado.createdAt);
            return createdAt.getFullYear() === anoGrafico;
        });

        const dadosGrafico = prepararDadosGraficoPorMes(dadosAnoAtual);
        setDadosGraficoMes(dadosGrafico);

        const dadosProvinciaAnoAtual = dadosEstabelecimento.filter(dado => {
            const createdAt = new Date(dado.createdAt);
            return createdAt.getFullYear() === anoAtual;
        });

        const dadosProvinciaOrdenados = prepararDadosPorProvincia(dadosAnoAtual)
            .sort((a, b) => b.total - a.total);

        setChartDataProvincia(dadosProvinciaOrdenados);
    }, [anos, dataInicial, dataFinal, currentPage, itemsPerPage, dadosEstabelecimento, provinciaSelecionadaGrafico]);

    useEffect(() => {
        async function generatePdf() {
            if (dadosEstabelecimentoTotal.length > 0) {
                const pdfDocGenerator = await PdfRelatorioGeral(dadosEstabelecimentoTotal);
                pdfDocGenerator.getDataUrl((dataUrl: any) => {
                    if (iframeRef.current) {
                        iframeRef.current.src = dataUrl;
                    }
                });
            }
        }
        generatePdf();
    }, [dadosEstabelecimentoTotal]);



    const selecionaAno = (event: { target: { value: string } }) => {
        setAnos(event.target.value);
        //  setesperaDados(true);
        setCurrentPage(1);
    };


    const abrirPdfnoBrowser = async (dadosEstabelecimentoSubTotal: any) => {
        const pdfGerarAquivo = await PdfRelatorioGeral(dadosEstabelecimentoSubTotal);
        pdfGerarAquivo.open();
    };

    const LimparFiltros = () => {
        return (
            <Button
                size="small"
                variant="contained"
                style={{ backgroundColor: '#85287e', padding: 7, maxWidth: 150 }}
                onClick={() => {
                    setProvincia('');
                    setDataFim('');
                    setDataInicio('');
                    setProvinciaSelecionada('');
                    setSelectedTipos('');
                    setDados('Activo');
                    setAnos('');
                    setMunicipio('');
                    setDataFimAprovacao('');
                    setDataInicioAprovacao('');
                    localStorage.removeItem('periodoSelecionado');
                }} >
                Limpar filtos
            </Button>
        )
    }

    return (
        esperaDados
            ?
            <DashboardSkeleton />
            :
            <div className="page-container">
                <div className="filters-container">
                    <DialogActions>
                        <Button style={{ backgroundColor: '#85287e', padding: 7 }} size='small' variant="contained" onClick={() => abrirPdfnoBrowser(dadosEstabelecimentoSubTotal)} >
                            <PictureAsPdfOutlined sx={{ mr: 1 }} />
                            Gerar Pdf
                        </Button>
                        <LimparFiltros />
                    </DialogActions>
                </div>

                <div style={{ marginTop: 10 }}>
                    <div className="content-row">
                        <div className="table-container">
                            <Card variant="outlined" sx={{ width: '100%', overflow: 'hidden', }} >
                                <TableContainer >
                                    <Table id="myTable" size="small" stickyHeader aria-label="sticky table">
                                        <TableHead >
                                            <TableRow>
                                                <TableCell ><Typography noWrap> <strong>Nome</strong></Typography></TableCell>
                                                <TableCell ><Typography display={'flex'} alignItems={'center'} noWrap>
                                                    <strong>Tipo</strong>
                                                    <CategoriaFilter tipo={selectedTipos} setTipo={setSelectedTipos} />
                                                </Typography></TableCell>
                                                <TableCell ><Typography noWrap> <strong>Director Técnico</strong></Typography></TableCell>
                                                <TableCell ><Typography display={'flex'} alignItems={'center'} noWrap>
                                                    <strong>Provincia</strong>
                                                    <ProvinciaFilter setProvinciaId={setProvinciaId} provincia={provincia} setProvincia={setProvincia} />
                                                </Typography></TableCell>
                                                <TableCell ><Typography display={'flex'} alignItems={'center'} noWrap>
                                                    <strong>Município</strong>
                                                    <MunicipioFilter provinciaId={provinciaId} municipio={municipio} setMunicipio={setMunicipio} />
                                                </Typography></TableCell>

                                                <TableCell ><Typography display={'flex'} alignItems={'center'} noWrap>
                                                    <strong>Data Inscrição</strong>
                                                    <DataInicioFimFilter
                                                        setDataInicio={setDataInicio}
                                                        setDataFim={setDataFim}
                                                        dataInicio={dataInicial}
                                                        dataFim={dataFinal}

                                                        anos={anos}
                                                        selecionaAno={selecionaAno}
                                                        anosFiltro={anosFiltro}
                                                    />
                                                </Typography></TableCell>

                                                <TableCell ><Typography display={'flex'} alignItems={'center'} noWrap>
                                                    <strong>Data Aprovação</strong>
                                                    <DataInicioFimFilter
                                                        setDataInicio={setDataInicioAprovacao}
                                                        setDataFim={setDataFimAprovacao}
                                                        dataInicio={dataAprovacaoInicio}
                                                        dataFim={dataAprovacaoFim}

                                                        anos={anos}
                                                        selecionaAno={selecionaAno}
                                                        anosFiltro={anosFiltro}
                                                    />
                                                </Typography></TableCell>


                                                <TableCell ><Typography display={'flex'} alignItems={'center'} noWrap>
                                                    <strong>Estado</strong>
                                                    <EstadoEstabelecimentoFilter filtro={dados} setFiltro={setDados} />
                                                </Typography></TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {dadosEstabelecimentoPaginated.map((estabelecimento) => (
                                                <TableRow key={estabelecimento?._id} title={estabelecimento?.nome}>
                                                    <TableCell >{estabelecimento?.nome}</TableCell>
                                                    <TableCell >{estabelecimento?.tipo?.designacao ?? 'N/A'}</TableCell>
                                                    <TableCell >{estabelecimento?.directorTecnico?.dadosPessoais?.nome}</TableCell>
                                                    <TableCell >{estabelecimento?.provincia}</TableCell>
                                                    <TableCell >{estabelecimento?.municipio}</TableCell>
                                                    <TableCell >{new Date(estabelecimento?.createdAt).getFullYear()}</TableCell>
                                                    <TableCell >{estabelecimento?.dataAprovacao ? new Date(estabelecimento?.dataAprovacao).getFullYear() : 'N/A'}</TableCell>
                                                    <TableCell >  <StatusEstabelecimento status={estabelecimento?.status} /></TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>

                                    <Paginacao
                                        configLista={configLista}
                                        lista={dadosEstabelecimentoPaginated}
                                        perPage={perPage}
                                        page={page}
                                        setPage={setPage}
                                        setPerPage={setPerPage}
                                        setOrder={() => { }}
                                    />

                                    {dadosEstabelecimentoPaginated.length === 0 &&
                                        <ListaVazia text={"Nenhum estabelecimento encontrado com os filtros selecionados."} >
                                            <LimparFiltros />
                                        </ListaVazia>
                                    }
                                </TableContainer>
                            </Card>
                        </div>

                        {isDesktop &&
                            <iframe
                                ref={iframeRef}
                                style={{ height: 'auto', border: '1px solid #ccc' }}
                                title="Gestor de Documentos"
                            />
                        }
                    </div>

                    <div >
                        <GraficoEstabelecimento
                            chartData={dadosGraficoMes}
                            ano={anoGrafico}
                            chartDataProvincia={chartDataProvincia}
                            provinciaSelecionada={provinciaSelecionadaGrafico}
                            setProvinciaSelecionada={setProvinciaSelecionadaGrafico}
                        />
                    </div>
                </div>
            </div>
    )
}
